import { FC } from 'react';
import { Card } from './Card';

interface CloudService {
  name: string;
  logo: string;
  description: string;
  badge?: string;
  url: string;
  features: string[];
  bgColor: string;
  textColor: string;
  badgeColor?: string;
}

interface CloudServiceAdProps {
  className?: string;
}

export const CloudServiceAd: FC<CloudServiceAdProps> = ({ className = '' }) => {
  const cloudServices: CloudService[] = [
    {
      name: '阿里云',
      logo: '☁️',
      description: '国内领先的云计算服务平台',
      badge: '国内优选',
      url: 'https://www.aliyun.com/minisite/goods?userCode=saru70kd',
      features: [
        '高性能云服务器',
        '全球CDN加速',
        '企业级安全保障',
        '7×24小时技术支持'
      ],
      bgColor: 'from-orange-50 to-red-50',
      textColor: 'text-orange-800',
      badgeColor: 'bg-orange-500'
    }
  ];

  return (
    <div className={`${className}`}>
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          推荐云服务合作伙伴
        </h3>
        <p className="text-gray-600">
          为您的AI编程项目提供稳定可靠的云基础设施
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {cloudServices.map((service, index) => (
          <Card key={index} className="h-full hover:shadow-xl transition-all duration-300">
            <div className={`bg-gradient-to-br ${service.bgColor} -m-6 mb-4 p-6 rounded-t-xl`}>
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center space-x-3">
                  <span className="text-3xl">{service.logo}</span>
                  <h4 className={`text-xl font-bold ${service.textColor}`}>
                    {service.name}
                  </h4>
                </div>
                {service.badge && (
                  <span className={`${service.badgeColor} text-white px-3 py-1 rounded-full text-sm font-medium`}>
                    {service.badge}
                  </span>
                )}
              </div>
              <p className={`${service.textColor.replace('800', '700')} font-medium`}>
                {service.description}
              </p>
            </div>
            
            <div className="space-y-3 mb-6">
              {service.features.map((feature, featureIndex) => (
                <div key={featureIndex} className="flex items-center space-x-2">
                  <span className="text-green-500">✓</span>
                  <span className="text-gray-700 text-sm">{feature}</span>
                </div>
              ))}
            </div>
            
            <div className="mt-auto">
              <a
                href={service.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-gradient-to-r from-primary-500 to-accent-400 hover:from-primary-600 hover:to-accent-500 text-white text-center py-3 rounded-lg font-semibold transition-all duration-200 hover:transform hover:-translate-y-0.5 hover:shadow-lg"
              >
                立即使用
              </a>
            </div>
          </Card>
        ))}
      </div>
      
      <div className="text-center mt-6">
        <p className="text-sm text-gray-500">
          * 通过我们的推荐链接注册，您将获得额外优惠，同时支持白茆AI的持续发展
        </p>
      </div>
    </div>
  );
};